<template>
    <div class="box bug">
        <p class="title">不具合について</p>
        <div class="formWrap">
            <el-form
                ref="bug"
                :rules="bugRules"
                :label-position="labelPosition"
                :model="bugForm"
                label-width="300px"
            >
                <el-form-item label="プレイヤー名" prop="name">
                    <el-input v-model="bugForm.name"></el-input>
                </el-form-item>
                <el-form-item label="プレイヤーID" prop="friendID">
                    <el-input v-model="bugForm.friendID"></el-input>
                    <span class="tip">※友人検索画面右上に表示</span>
                </el-form-item>
                <el-form-item label="メールアドレス" prop="email">
                    <el-input v-model="bugForm.email"></el-input>
                </el-form-item>
                <el-form-item class="required" label="メールアドレス（確認）" prop="reemail">
                    <el-input v-model="bugForm.reemail"></el-input>
                </el-form-item>
                <el-form-item label="発生した日時" prop="bugTime">
                    <el-date-picker
                        v-model="bugForm.bugTime"
                        type="date"
                        value-format="timestamp"
                        placeholder="日付を選択"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item class="required" label="発生した画面" prop="bugPicture">
                    <el-select v-model="bugForm.bugPicture.selVal" placeholder="選んでください">
                        <el-option
                            v-for="item in bugPicOptons"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                    <el-input
                        v-show="bugForm.bugPicture.selVal == 4 || bugForm.bugPicture.selVal == 5"
                        style="margin-top: 10px;"
                        v-model="bugForm.bugPicture.inputVal"
                    ></el-input>
                    <span
                        class="tip"
                        v-show="bugForm.bugPicture.selVal == 4"
                    >牌譜URL（牌譜画面の「シェア」ボタンから確認できます）</span>
                </el-form-item>
                <el-form-item label="発生前後に行った操作" prop="beforeAction">
                    <el-input v-model="bugForm.beforeAction"></el-input>
                </el-form-item>
                <el-form-item label="エラーメッセージ文（表示されている場合）" prop="errorMsg">
                    <el-input v-model="bugForm.errorMsg"></el-input>
                </el-form-item>
                <el-form-item label="利用端末・ブラウザ" prop="device">
                    <el-input v-model="bugForm.device"></el-input>
                </el-form-item>
                <el-form-item class="checkboxWrap" label="通信環境" prop="network">
                    <el-checkbox-group v-model="bugForm.network">
                        <el-checkbox label="NTTドコモ" name="network"></el-checkbox>
                        <el-checkbox label="au" name="network"></el-checkbox>
                        <el-checkbox label="Softbank" name="network"></el-checkbox>
                        <el-checkbox label="Wi-Fi" name="network"></el-checkbox>
                        <el-checkbox label="光ファイバー" name="network"></el-checkbox>
                        <el-checkbox label="CATV" name="network"></el-checkbox>
                        <el-checkbox label="ADSL" name="network"></el-checkbox>
                        <el-checkbox label="ISDN" name="network"></el-checkbox>
                        <el-checkbox label="その他" name="network"></el-checkbox>
                    </el-checkbox-group>
                    <span class="tip">
                        ※ゲームをプレイする際の通信環境を全て選択してください。
                        <br>その他を選択した場合、通信環境を入力してください。
                    </span>
                    <el-input
                        v-show="bugForm.network.indexOf('その他') != -1"
                        v-model="bugForm.otherNetwork"
                    ></el-input>
                </el-form-item>
                <el-form-item label="発生した問題の詳細内容" prop="content">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 5}"
                        v-model="bugForm.content"
                    ></el-input>
                </el-form-item>
                <el-form-item class="required" label="個人情報の取り扱いについて" prop="perChecked">
                    <el-checkbox v-model="bugForm.perChecked">同意する</el-checkbox>
                    <a
                        class="checked"
                        target="_blank"
                        href="https://mahjongsoul.com/privacy_policy"
                    >※プライバシーポリシーをご確認ください。</a>
                </el-form-item>
                <el-form-item label>
                    <el-button size="medium" type="info" plain @click="bugConfirm">上記内容で送信</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        // 自定义表单验证规则
        const bug_reemail = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("もう一度メールアドレスを入力してください"));
            } else if (value !== this.bugForm.email) {
                callback(new Error("メールアドレスが一致しません"));
            } else {
                callback();
            }
        };
        const bug_picture = (rule, value, callback) => {
            if (!value.selVal) {
                callback(new Error("必須"));
            } else if (value.selVal == 4 || value.selVal == 5) {
                if (!value.inputVal) {
                    callback(new Error("必須"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };

        const bug_perChecked = (rule, value, callback) => {
            if (!value) {
                callback(new Error("同意してください"));
            } else {
                callback();
            }
        };

        return {
            labelPosition: "right",
            bugRules: {
                name: [{ required: true, message: "必須", trigger: "blur" }],
                friendID: [
                    { required: true, message: "必須", trigger: "blur" }
                ],
                email: [
                    {
                        required: true,
                        message: "必須",
                        trigger: "blur"
                    },
                    {
                        type: "email",
                        message: "正しいメールアドレスを入力してください",
                        trigger: ["blur", "change"]
                    }
                ],
                reemail: [
                    {
                        trigger: "blur",
                        validator: bug_reemail
                    }
                ],
                bugTime: [
                    {
                        type: "date",
                        required: true,
                        message: "必須",
                        trigger: "change"
                    }
                ],
                bugPicture: [{ trigger: "change", validator: bug_picture }],
                device: [{ required: true, message: "必須", trigger: "blur" }],
                content: [{ required: true, message: "必須", trigger: "blur" }],
                perChecked: [
                    {
                        trigger: "change",
                        validator: bug_perChecked
                    }
                ]
            },
            bugPicOptons: [
                {
                    value: "1",
                    label: "ローディング画面"
                },
                {
                    value: "2",
                    label: "ログイン画面"
                },
                {
                    value: "3",
                    label: "メイン画面"
                },
                {
                    value: "4",
                    label: "対局画面"
                },
                {
                    value: "5",
                    label: "その他"
                }
            ],
            bugForm: {
                name: "",
                friendID: "",
                email: "",
                reemail: "",
                bugTime: "",
                bugPicture: {
                    selVal: "",
                    inputVal: ""
                },
                beforeAction: "",
                errorMsg: "",
                device: "",
                network: [],
                otherNetwork: "",
                content: "",
                perChecked: false
            }
        };
    },
    created() {
        if (!this.$utils.isPC()) {
            this.labelPosition = "top";
        }
    },
    methods: {
        mapOptionsLable(options, value) {
            for(let i = 0, len = options.length; i < len; i++) {
                if(options[i].value == value) {
                    return options[i].label;
                }
            }
        },
        bugConfirm() {
            this.$refs["bug"].validate(valid => {
                if(!valid) {
                    return false;
                } else {
                    if(confirm('ご入力いたたいた内容で送信してよろしいでしょうか？')) {
                        this.confirm();
                    } else {
                        return false;
                    }
                }
            });
        },
        confirm() {
            let formData = new FormData();
            formData.set("name", this.bugForm.name);
            formData.set("friendID", this.bugForm.friendID);
            formData.set("email", this.bugForm.email);
            formData.set("bugTime", this.bugForm.bugTime);
            formData.set("bugPicture",
                this.mapOptionsLable(this.bugPicOptons, this.bugForm.bugPicture.selVal) + " ： " + this.bugForm.bugPicture.inputVal
            )
            formData.set("beforeAction", this.bugForm.beforeAction);
            formData.set("errorMsg", this.bugForm.errorMsg ? this.bugForm.errorMsg : 'X');
            formData.set("device", this.bugForm.device);
            formData.set("network", this.bugForm.network.join(", ") + " <br>その他：" + this.bugForm.otherNetwork);
            formData.set("content", this.bugForm.content);
            // bug
            formData.set("type", "3")   
            formData.set("title", "不具合について")

            this.$message({
                message:'送信が成功',
                duration: 10000
            });

            this.axios.post("/service/dismail",formData ).then(v => {
                console.log(v)
                if(v.data.retcode == 1) {
                    // 清空表单
                    /* this.bugForm.name = "";
                    this.bugForm.friendID = "";
                    this.bugForm.email = "";
                    this.bugForm.reemail = "";
                    this.bugForm.bugTime = "";
                    this.bugForm.bugPicture.selVal = "";
                    this.bugForm.bugPicture.inputVal = "";
                    this.bugForm.beforeAction = "";
                    this.bugForm.errorMsg = "";
                    this.bugForm.device = "";
                    this.bugForm.network = [];
                    this.bugForm.otherNetwork = "";
                    this.bugForm.content = "";
                    this.bugForm.perChecked = false; */
                }
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        bugForm: {
            handler(val) {
                if(val.bugPicture.selVal != 4 && val.bugPicture.selVal != 5) {
                    this.bugForm.bugPicture.inputVal = "";
                }
                if(val.network.indexOf("その他") == -1) {
                    this.bugForm.otherNetwork = "";
                }
            },
            deep: true
        }
    }
};
</script>


<style lang="scss" scoped>
.box {
    width: 100%;
    box-sizing: border-box;
    color: #fff;

    & ::v-deep .el-button {
        background: transparent;
    }

    .title {
        width: 100%;
        background: #000;
        box-sizing: border-box;
        padding: pxTorem(10px) pxTorem(20px) pxTorem(10px) pxTorem(50px);
        .back {
            font-size: pxTorem(24px);
            cursor: pointer;
        }
    }
    .formWrap {
        width: 80%;
        margin: 0 auto;
        box-sizing: border-box;
        padding: pxTorem(10px) pxTorem(20px);

        @media screen and (max-width: 600px) {
            width: 100%;
        }

        & ::v-deep .el-form-item__label {
            color: #fff;
        }
        & ::v-deep .el-input__inner {
            color: #fff;
        }
        & ::v-deep .el-textarea__inner {
            background: transparent;
            color: #fff;
            font-family: $japaneseFontFamily;
            &::-webkit-scrollbar {
                width: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: #001238;
                border-radius: 8px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #407cfd;
                border-radius: 8px;
            }
        }
        .tip {
            font-size: pxTorem(10px);
            color: #afafaf;
        }
        .checked {
            color: #ac7f00;
        }
        .el-upload__tip {
            color: #afafaf;
            line-height: 1.5;
        }
        & ::v-deep .el-upload-list__item {
            height: auto !important;
            border: 1px solid transparent;
        }
        & ::v-deep .el-upload-list__item:hover {
            background: transparent;
            border: 1px solid #fff;
        }
        & ::v-deep .el-upload-list__item-name {
            color: #fff;
        }
        & ::v-deep .el-icon-document {
            color: #fff;
        }
        & ::v-deep .el-icon-close {
            color: #fff;
        }
        .inputsBox {
            .el-input:not(:last-child) {
                margin-bottom: 10px;
            }
        }
        .checkboxWrap {
            .el-checkbox {
                color: #fff;
            }
        }
    }
}
</style>